
export const financebasic = {
  accountcat: {
    service:{
      name:'accountcat',
      title:'Account Category',
    }
  },

  accountstate: {
    service:{
      name:'accountstate',
      title:'Account State',
    }
  },

  accounttype: {
    service:{
      name:'accounttype',
      title:'Account Type',
    }
  },
};
